import React from "react"
import {
  AppLoginHeader,
  AppLoginContainer,
  LoginButton,
  LearnMoreButton,
  InstallButton
} from "./Login.styles"
import msTeamLogo from "../../assets/image/msteams 1.png"
import { Typography } from "@mui/material"
import AzureAuthenticationContext from "src/services/ms-teams/ms-teams.service"
import { authService } from "src/services/auth.service"
import { useHistory } from "react-router-dom"
import { useAppDispatch } from "../../hooks/redux"
import { tokenService } from "../../services/token.service"
import { messages } from "../../utils/constants/messages"
import { SeverityEnum } from "../../utils/enums/toast.enum"
import { PATH } from "../../utils/constants/path.constants"
import { toastHelpers } from "../../utils/helpers/toast.helpers"
import { loginSuccess } from "src/reducer/app.reducer"
const MSTeamsLogin = () => {
  const authenticationModule: AzureAuthenticationContext =
    new AzureAuthenticationContext()
  const history = useHistory()
  const dispatch = useAppDispatch()

  const logIn = (): any => {
    authenticationModule.login().then(
      res => {
        authService.login(res.idToken, "msteams_login").then(
          result => {
            const authenticateRes = result.data.data
            tokenService.updateLocalAccessToken(authenticateRes.id_token)
            tokenService.updateRefreshToken(authenticateRes.refresh_token)
            tokenService.updateUserId(`${authenticateRes.user_id}`)
            toastHelpers.handleToast(
              dispatch,
              messages.auth.success,
              SeverityEnum.SUCCESS
            )
            dispatch(loginSuccess())
            history.push(PATH.DASHBOARD)
          },
          error => {
            toastHelpers.handleToast(
              dispatch,
              messages.auth.msteams,
              SeverityEnum.ERROR
            )
          }
        )
      },
      () => {
        toastHelpers.handleToast(
          dispatch,
          messages.auth.msteams,
          SeverityEnum.ERROR
        )
      }
    )
  }
  return (
    <AppLoginContainer>
      <AppLoginHeader>
        <img src={msTeamLogo} alt="" width="32" height="32" />
        <Typography sx={{ ml: 2 }} variant="subtitle2">
          Microsoft Teams
        </Typography>
      </AppLoginHeader>
      <LoginButton id="authenticationButton" onClick={logIn}>
        Login with Microsoft Teams
      </LoginButton>
      <InstallButton
        href="https://teams.microsoft.com/l/app/724b774e-aa53-4d2d-885b-6008c114cb37"
        target={"_blank"}
      >
        Install
      </InstallButton>
      <Typography sx={{ fontSize: 14, mt: 2 }} variant="body2">
        Or send<strong>&nbsp;@StandupAlice Status&nbsp;</strong>in a channel
      </Typography>
      <LearnMoreButton
        href={
          "https://standupalice.freshdesk.com/support/solutions/folders/35000211394"
        }
        target={"_blank"}
      >
        Learn more
      </LearnMoreButton>
    </AppLoginContainer>
  )
}

export default MSTeamsLogin
